'use client';

import React from 'react';
import Breadcrumb from '@/components/ui/Breadcrumb';
import { SectionStack } from '@/components/ui/SectionStack';
import { Hero } from '@/features/b2b/resources/components/marketing-toolkit/request-toolkit/Hero';
import { Resources } from '@/features/b2b/resources/components/marketing-toolkit/request-toolkit/Resources';

const breadcrumbItems = [
  {
    label: 'Resources',
    labelMobile: '...',
    href: '/professionals/resources',
  },
  { label: 'Marketing toolkit', href: '/professionals/resources/marketing-toolkit', labelMobile: '...' },
  { label: 'Request toolkit', href: '/professionals/resources/marketing-toolkit/print-marketing' },
];

export const RequestToolkit = () => (
  <SectionStack>
    <div>
      <div className="container mx-auto">
        <div className="pt-3">
          <Breadcrumb items={breadcrumbItems}/>
        </div>
      </div>
      <Hero />
    </div>
    <Resources />
  </SectionStack>
);
